export default __webpack_public_path__ + "static/get_eBRC-6692f3ae9f0f6e7f1056fc1968f8b3f4.png";